/* eslint-disable react-hooks/rules-of-hooks */
import axios from "axios";
import { Button } from "rsuite";
import posthog from "posthog-js";
import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import PhoneInput from "react-phone-number-input/input";
import { isValidPhoneNumber } from "react-phone-number-input";

import AuthService from "../../services/auth.service";
import MessageHandle from "../../services/MessageHandle";
import CampaignService from "../../services/campaign.service";
import { CountrySelect } from "../CountrySelect/CountrySelect";

import BackIcon from "../../img/back.svg";

import "./authentication.css";
import "react-phone-number-input/style.css";
import "react-toastify/dist/ReactToastify.css";

const APP_URL = process.env.APP_URL;

const Authentication = (props) => {
  const { viewType, successCallback, backCallback, setAuthStep, hasUserForm } =
    props;

  const [containerClass, setContainerClass] = useState("");
  const [mobile, setMobile] = useState(props.mobile ?? "");
  const [email, setEmail] = useState(props.email ?? "");

  const whichForm = props.whichForm ?? "old";
  const [verificationCode, setVerificationCode] = useState("");
  const [step, setStep] = useState("mobile-step");

  const [country, setCountry] = useState();
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [information, setInformation] = useState({
    name: "",
    surname: "",
  });

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    if (step === "email-step" && mobile) {
      window.dataLayer.push({
        event: "form_v2_step_change",
        step: 7,
        has_form: hasUserForm,
        mobile: mobile,
      });
    }
  }, [step, mobile]);

  const [verificationSubmitButtonStatus, setVerificationSubmitButtonStatus] =
    useState(false);

  if (AuthService.getCurrentUser() && !successCallback) {
    entranceAfterLogin();
    // window.location.replace('/');
    return <></>;
  }

  useEffect(() => {
    window.addEventListener("popstate", function (event) {
      if (backCallback) {
        backCallback();
      } else {
        handleBrowserBack();
      }
    });
  }, [step]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  return (
    <div className={`container ${containerClass}`}>
      <div
        className={`form-container ${
          viewType === "inline" ? "form-container-inline" : ""
        }`}
      >
        {step === "mobile-step" ? mobileStep() : ""}
        {step === "email-step" ? emailStep() : ""}
        {step === "verification-step" ? verificationStep() : ""}
        {step === "registration-step" ? registrationStep() : ""}
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );

  function backButton() {
    return (
      <button className="btn-back" onClick={handleBack}>
        <img src={BackIcon} alt="back" />
      </button>
    );
  }

  function mobileStep() {
    useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "form_authentication",
        step: "mobile",
      });
    }, []);

    return (
      <>
        <div className="authentication-form mobile-step">
          <label htmlFor="phone" className="!text-[#363636] !font-medium">
            لطفا شماره موبایل خود را وارد کنید
          </label>
        </div>

        <div dir="ltr" className="relative flex gap-2 mb-8 items-center">
          <CountrySelect
            country={country}
            mobile={mobile}
            setCountry={setCountry}
          />
          <PhoneInput
            id="phone"
            placeholder=""
            value={mobile ?? ""}
            onChange={setMobile}
            international
            country={country}
            className="flex h-12 w-full rounded border border-[#CECCCC] !border-solid focus-within:border-[#363636] bg-background p-3 text-sm ring-offset-0 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50"
          />
        </div>
        <Button
          className="next-button"
          appearance={isLoading ? "default" : "primary"}
          onClick={handleSendOTP}
          disabled={!isValidPhoneNumber(mobile ?? "", country)}
          loading={isLoading}
          block
        >
          ادامه
        </Button>
      </>
    );
  }

  function verificationStep() {
    useEffect(() => {
      window.dataLayer.push({
        event: "form_authentication",
        step: "verification",
        mobile: mobile,
      });
    }, []);

    const mobileShow = "0" + mobile.substring(3);

    return (
      <>
        {backButton()}

        <div className="authentication-form verification-step">
          {email ? (
            <div className="flex flex-col">
              <label>کد 4 رقمی ارسال شده به ایمیل زیر را وارد کنید</label>
              <label>{email}</label>
            </div>
          ) : (
            <label>
              کد 4 رقمی ارسال شده به شماره {mobileShow} را وارد کنید
            </label>
          )}
          <button className="btn btn-mobile-step " onClick={handleBack}>
            {email ? "تغییر ایمیل" : "تغییر شماره موبایل"}
          </button>
          <input
            name="code"
            id="code"
            autoFocus={true}
            autoComplete="one-time-code"
            inputMode="numeric"
            minLength={4}
            maxLength={4}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={(e) => (e.key === "Enter" ? handleVerifyOTP() : null)}
            onChange={(e) => handleChangeVerificationCode(e)}
          />

          <div className="resend-text">
            {seconds > 0 || minutes > 0 ? (
              <div className="text-right">
                <div className="d-inline" style={{ marginLeft: "1rem" }}>
                  {email ? "ایمیلی" : "پیامکی"} دریافت نکرده اید؟
                </div>
                <div
                  className="d-inline"
                  style={{
                    marginLeft: ".2rem",
                    marginRight: ".2rem",
                  }}
                >
                  {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </div>
                تا ارسال مجدد
              </div>
            ) : (
              <Button
                className="btn"
                onClick={email ? handleSendEmailOTP : handleSendOTP}
                loading={isLoading}
              >
                ارسال مجدد
              </Button>
            )}
            <div className="terms-and-rules">
              ادامه به منزله پذیرفتن{" "}
              <b>
                <a
                  href={`${
                    process.env.NEXT_APP_URL ?? "https://changaal.com"
                  }/pages/rules`}
                >
                  شرایط و قوانین
                </a>
              </b>{" "}
              چنگال است.
            </div>
          </div>
        </div>

        <div className="!relative !py-8 !w-full">
          <Button
            className="next-button"
            appearance={isLoading ? "default" : "primary"}
            onClick={() => handleVerifyOTP()}
            disabled={!verificationSubmitButtonStatus}
            loading={isLoading}
            block
          >
            ارسال
          </Button>
          {email && (
            <div className="flex p-3 bg-[#FEFEE880] rounded-xl flex-col gap-4 mt-8">
              <div className="flex items-center gap-2">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9997 20H3.99969C3.64119 20 3.31119 19.8085 3.13269 19.498C2.95469 19.1875 2.95569 18.8055 3.13619 18.496L11.1362 4.496C11.3152 4.189 11.6442 4 11.9997 4C12.3552 4 12.6842 4.189 12.8637 4.496L20.8637 18.496C21.0442 18.8055 21.0452 19.1875 20.8672 19.498C20.6892 19.8085 20.3577 20 19.9997 20Z"
                    fill="#FFC107"
                  />
                  <path
                    d="M11 17.071C11 16.9365 11.0235 16.8135 11.0715 16.698C11.1185 16.584 11.186 16.485 11.273 16.402C11.3585 16.318 11.464 16.2525 11.585 16.2055C11.707 16.1595 11.844 16.135 11.997 16.135C12.15 16.135 12.288 16.1595 12.411 16.2055C12.536 16.2525 12.6415 16.318 12.727 16.402C12.8145 16.485 12.882 16.584 12.9285 16.698C12.9765 16.8135 13 16.9365 13 17.071C13 17.206 12.9765 17.329 12.9285 17.441C12.8815 17.5535 12.814 17.6505 12.727 17.735C12.6415 17.818 12.536 17.883 12.411 17.931C12.288 17.977 12.15 18 11.997 18C11.8435 18 11.707 17.977 11.585 17.9305C11.464 17.8825 11.3585 17.8175 11.273 17.7345C11.1855 17.65 11.118 17.553 11.0715 17.4405C11.0235 17.3285 11 17.2055 11 17.071ZM12.74 15H11.2535L11.043 9H12.95L12.74 15Z"
                    fill="#5D4037"
                  />
                </svg>
                <span className="text-sm font-semibold text-[#1F2323]">
                  توجه!
                </span>
              </div>
              <p className="text-sm text-[#566463] text-start">
                در صورتی که کد تایید رو در صندوق ورودی (Inbox) مشاهده نکردید،
                لطفاً پوشه اسپم (Spam) رو هم بررسی کنید. 
              </p>
            </div>
          )}
        </div>
      </>
    );
  }

  function emailStep() {
    useEffect(() => {
      window.dataLayer.push({
        event: "form_authentication",
        step: "email-step",
        mobile: mobile,
        // email: email,
      });
    }, []);
    const isValidEmail = (email) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(email);
    };

    return (
      <>
        {backButton()}

        <div className="authentication-form mobile-step">
          <label htmlFor="email" className="!text-[#363636] !font-medium">
            لطفا ایمیل خود را وارد کنید
          </label>
        </div>

        <div
          style={{ display: "flex", gap: 4, position: "relative" }}
          dir="ltr"
        >
          <input
            id="email"
            value={email ?? ""}
            className="flex h-12 w-full rounded border !border-solid border-[#CECCCC] focus-within:border-[#363636] bg-background p-3 text-sm ring-offset-0 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 mb-8"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <Button
          className="next-button"
          appearance={isLoading ? "default" : "primary"}
          onClick={handleSendEmailOTP}
          disabled={!isValidEmail(email)}
          loading={isLoading}
          block
        >
          ادامه
        </Button>
      </>
    );
  }

  function registrationStep() {
    useEffect(() => {
      window.dataLayer.push({
        event: "form_authentication",
        step: "registration",
        mobile: mobile,
      });
    }, []);

    return (
      <>
        {backButton()}

        <div className="authentication-form registration-step">
          <label>نام خود را وارد کنید</label>
          <input
            name="name"
            id="name"
            autoComplete="off"
            autoFocus={true}
            onBlur={onBlur}
            onFocus={onFocus}
            placeholder="نام"
            onChange={(e) => handleChangeInformation(e)}
          />

          <label style={{ marginTop: "1.5rem" }}>
            نام خانوادگی خود را وارد کنید
          </label>
          <input
            name="surname"
            id="surname"
            autoComplete="off"
            autoFocus={false}
            onBlur={onBlur}
            onFocus={onFocus}
            placeholder="نام خانوادگی"
            onKeyDown={(e) => (e.key === "Enter" ? handleRegister() : null)}
            onChange={(e) => handleChangeInformation(e)}
          />
        </div>

        <div className="form-bottom">
          <Button
            appearance={isLoading ? "default" : "primary"}
            onClick={handleRegister}
            loading={isLoading}
            block
          >
            ادامه
          </Button>
        </div>
      </>
    );
  }

  function handleBrowserBack() {
    setStep("mobile-step");
    addUrlParameter("step", "mobile-step");
    addUrlParameter("p", "");
    addUrlParameter("s", "");
    addUrlParameter("step", "");
  }

  function handleBack() {
    switch (step) {
      case "mobile-step":
        setContainerClass("");
        if (viewType === "inline") {
          backCallback();
        }
        break;

      case "email-step":
        setContainerClass("");
        setStep("mobile-step");
        addUrlParameter("step", "mobile-step");
        break;

      case "verification-step":
        setContainerClass("");
        if (email) {
          setStep("email-step");
          addUrlParameter("step", "email-step");
        } else {
          setStep("mobile-step");
          addUrlParameter("step", "mobile-step");
        }
        break;

      case "registration-step":
        setContainerClass("");
        setStep("mobile-step");
        break;

      case "notfound":
        setContainerClass("");
        setStep("notfound");
        addUrlParameter("step", "sotfound");
        break;
      default:
        break;
    }
  }

  function handleChangeInformation(event) {
    let informationChange = { ...information };
    informationChange[event.target.name] = event.target.value;
    setInformation(informationChange);
  }

  function handleChangeVerificationCode(event) {
    setVerificationCode(event.target.value);

    if (event.target.value.length === 4) {
      handleVerifyOTP(event.target.value);
      setVerificationSubmitButtonStatus(true);
    } else {
      setVerificationSubmitButtonStatus(false);
    }
  }

  function onBlur() {
    setContainerClass("");
  }

  function onFocus() {
    setContainerClass("on-keyboard");
  }

  function handleSendOTP() {
    if (isLoading) {
      return false;
    }

    setMinutes(1);
    setSeconds(30);

    const body = {
      mobile: mobile,
      ...(email ? { email: email } : undefined),
    };
    const formType = getUrlParameter("form_type");
    setIsLoading(true);

    axios
      .post(
        `${APP_URL}/api/v6/authentication/send-otp?form_type=${formType}`,
        body
      )
      .then(function (response) {
        if (setAuthStep) {
          if (country === "IR") {
            setAuthStep("verification-step");
            setStep("verification-step");
            addUrlParameter("step", "verification-step");
            setIsLoading(false);
          } else {
            setAuthStep("email-step");
            setStep("email-step");
            addUrlParameter("step", "email-step");
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
          if (country === "IR") {
            setStep("verification-step");
            addUrlParameter("step", "verification-step");
          } else {
            setStep("email-step");
            addUrlParameter("step", "email-step");
          }
          setContainerClass("");
          addUrlParameter("p", "mobile-step");
        }
      })
      .catch(function (error) {
        //throw new Error('Hulk smash!'.error);
        setIsLoading(false);

        if (!error.response) {
          handleNotfound();
          return false;
        }
        MessageHandle.error(error);
      });
  }
  function handleSendEmailOTP() {
    if (isLoading) {
      return false;
    }

    setMinutes(1);
    setSeconds(30);

    const body = {
      email: email,
      mobile: mobile,
    };
    const formType = getUrlParameter("form_type");
    setIsLoading(true);

    axios
      .post(
        `${APP_URL}/api/v6/authentication/send-otp?form_type=${formType}`,
        body
      )
      .then(function (response) {
        if (setAuthStep) {
          setAuthStep("verification-step");
          setStep("verification-step");
          addUrlParameter("step", "verification-step");
          setIsLoading(false);
        } else {
          setIsLoading(false);

          setContainerClass("");
          setStep("verification-step");
          addUrlParameter("step", "verification-step");
          if (setAuthStep) {
            setAuthStep("verification-step");
            addUrlParameter("step", "verification-step");
          }
        }
      })
      .catch(function (error) {
        //throw new Error('Hulk smash!'.error);
        setIsLoading(false);

        if (!error.response) {
          handleNotfound();
          return false;
        }
        MessageHandle.error(error);
      });
  }

  function handleRegister() {
    if (isLoading) {
      return false;
    }

    setMinutes(1);
    setSeconds(30);

    let body = {
      mobile: mobile,
      code: verificationCode,
      name: information.name,
      surname: information.surname,
      ...(email ? { email: email } : undefined),
    };

    const campaignParameters = CampaignService.get();

    body = { ...body, ...campaignParameters };

    setIsLoading(true);

    axios
      .post(`${APP_URL}/api/v6/authentication/register`, body)
      .then(function (response) {
        window.dataLayer.push({
          event: "form_authentication",
          step: "success_registration",
          mobile: body.mobile,
          name: body.name,
          surname: body.surname,
        });
        const user = response.data?.user;
        posthog.identify(user.mobile, {
          email: user?.email,
          country_id: user?.user,
          gender: user?.gender,
          id: user?.id,
          name: user?.name,
          surname: user?.surname,
          username: user?.username,
          mobile: user?.mobile,
        });

        successAuth(response.data);
      })
      .catch(function (error) {
        window.dataLayer.push({
          event: "form_authentication",
          step: "failed_registration",
          mobile: body.mobile,
          name: body.name,
          surname: body.surname,
          error: error,
        });
        setIsLoading(false);

        if (!error.response) {
          handleNotfound();
          return false;
        }
        MessageHandle.error(error);
      });
  }

  function handleVerifyOTP(val = null) {
    if (isLoading) {
      return false;
    }

    const body = {
      mobile: mobile,
      code: val ? val : verificationCode,
      ...(email ? { email: email } : undefined),
      // email,
    };

    setIsLoading(true);

    axios
      .post(`${APP_URL}/api/v6/authentication/verify-otp`, body)
      .then(function (response) {
        if (!response.data?.result.status) {
          setIsLoading(false);
          toast.error(response.data?.result.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          return false;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "success_auth_otp",
          user_registration_status: whichForm,
        });

        window.dataLayer.push({
          event: "form_authentication",
          step: "success_verification",
          user_registration_status: whichForm,
          mobile: body.mobile,
        });

        if (response.data?.result?.user) {
          const user = response.data?.result?.user;

          posthog.identify(user.mobile, {
            email: user?.email,
            country_id: user?.user,
            gender: user?.gender,
            id: user?.id,
            name: user?.name,
            surname: user?.surname,
            username: user?.username,
            mobile: user?.mobile,
          });
          successAuth(response.data?.result);
        } else {
          setIsLoading(false);
          setContainerClass("");
          setStep("registration-step");
          addUrlParameter("step", "registration-step");

          addUrlParameter("s", "mobile-step");
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        if (!error.response) {
          handleNotfound();

          return false;
        }
        MessageHandle.error(error);
        window.dataLayer.push({
          event: "form_authentication",
          step: "failed_verification",
          user_registration_status: whichForm,
          mobile: body.mobile,
          error: error,
        });
      });
  }

  function successAuth(data) {
    localStorage.setItem("user", JSON.stringify(data));

    toast.success(data.message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    if (successCallback) {
      successCallback();
      return true;
    }
    entranceAfterLogin();
    // window.location.replace('/');
  }

  function addUrlParameter(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);

    let kvp = window.location.search.substr(1).split("&");
    if (kvp[0] === "") {
      const path =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        key +
        "=" +
        value;
      window.history.pushState({ path: path }, "", path);
    } else {
      let i = kvp.length;
      let x;
      while (i--) {
        x = kvp[i].split("=");

        if (x[0] === key) {
          x[1] = value;
          kvp[i] = x.join("=");
          break;
        }
      }

      if (i < 0) {
        kvp[kvp.length] = [key, value].join("=");
      }

      const refresh =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        kvp.join("&");
      window.history.pushState({ path: refresh }, "", refresh);
    }
  }

  function getUrlParameter(key) {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  }

  function handleNotfound() {
    localStorage.setItem("error", "PageNotFound");
    setIsLoading(false);
    //setStep('notfound');
    window.location.href = "";
  }

  function entranceAfterLogin() {
    let url = "/";

    if (AuthService.getHasActiveMeal()) {
      url = "/subscriptions/active-subscription";
    } else if (AuthService.getHasWeighing()) {
      url = "/subscriptions";
    }
    window.location.replace(url);
  }
};

export default Authentication;
